export default {
	GET_MONTH: ({ listId, year, month }) => {
		const queryParams = new URLSearchParams();
		queryParams.append("listId", listId);
		queryParams.append("year", year);
		queryParams.append("month", month);

		return `/economos/movement/month?${queryParams.toString()}`;
	},
	GET_WITH_FILTER: ({ listId, year, month }) => {
		const queryParams = new URLSearchParams();
		queryParams.append("listId", listId);
		queryParams.append("year", year);
		queryParams.append("month", month);

		return `/economos/movement/filter?${queryParams.toString()}`;
	},
	SEARCH: ({ list, dateFrom, dateTo, tags = [], name }) => {
		const searchParams = new URLSearchParams();
		if (list) searchParams.append("list", list);
		if (dateFrom) searchParams.append("dateFrom", dateFrom);
		if (dateTo) searchParams.append("dateTo", dateTo);
		if (tags) searchParams.append("tags", tags.join(","));
		if (name) searchParams.append("name", name);

		return `/economos/movement/search?${searchParams.toString()}`;
	},
	GET_RECOMMENDATION: ({ listId, date, amount, name, tags }) => {
		const searchParams = new URLSearchParams();
		if (listId) searchParams.append("listId", listId);
		if (date) searchParams.append("date", date);
		if (amount) searchParams.append("amount", amount);
		if (name) searchParams.append("name", name);
		if (tags) searchParams.append("tags", tags);

		return `/economos/movement/recommendation?${searchParams.toString()}`;
	},
	GET_TAGS: ({ listId }) => {
		const searchParams = new URLSearchParams();
		if (listId) searchParams.append("listId", listId);

		return `/economos/movement/tags?${searchParams.toString()}`;
	},
	CREATE: () => "/economos/movement",
	TRANSFER: () => "/economos/movement/transfer",
	UPDATE: () => "/economos/movement",
	DELETE: (id, { editMode } = {}) => {
		const params = new URLSearchParams();
		if (editMode) params.append("editMode", editMode);
		const qs = params.toString();
		return `/economos/movement/${id}${qs ? `?${qs}` : ""}`;
	},
	GET_SERIES: (recurrenceId) => `/economos/movement/series/${recurrenceId}`,
};
